import type { AgreementChange, FollowUp, Project } from './project';

const forbidden = /(업체\s*(?:과실|잘못)|배상해야|불법(?:이다|입니다)|사기\s*업체|책임이\s*확정)/;

export function isSafeAgreementText(value: string): boolean {
  return !forbidden.test(value.replace(/\s+/g, ' '));
}

export function activeAgreementChanges(project: Pick<Project,'agreementChanges'>): AgreementChange[] {
  const reverted = new Set(project.agreementChanges.filter((row) => row.kind === 'reverted' && row.revertsChangeId).map((row) => row.revertsChangeId));
  const latest = new Map<string, AgreementChange>();
  project.agreementChanges
    .filter((row) => row.kind !== 'reverted' && !reverted.has(row.id))
    .sort((left,right)=>left.createdAt.localeCompare(right.createdAt))
    .forEach((row)=>latest.set(row.itemId,row));
  return [...latest.values()].sort((left,right)=>right.createdAt.localeCompare(left.createdAt));
}

export function followUpDueState(followUp: FollowUp, today: string): 'resolved'|'overdue'|'due_soon'|'scheduled'|'undated' {
  if (followUp.status === 'resolved') return 'resolved';
  if (!followUp.dueOn) return 'undated';
  const days=(Date.parse(`${followUp.dueOn}T00:00:00Z`)-Date.parse(`${today}T00:00:00Z`))/86_400_000;
  if (days < 0) return 'overdue';
  if (days <= 2) return 'due_soon';
  return 'scheduled';
}

export function transitionFollowUp(followUp: FollowUp, status: FollowUp['status'], note: string, occurredAt: string): FollowUp {
  return {
    ...followUp,
    status,
    events:[...followUp.events,{id:crypto.randomUUID(),status,note:note.trim(),occurredAt}],
    updatedAt:occurredAt
  };
}
